import { combineReducers } from "redux";
import responses from "./responses";
import gradebook from "./gradebook";

const grades = combineReducers({
  gradebook,
  responses
});

export default grades;
